// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

// Detect Mobile Function
window.mobileAndTabletcheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

/**
 * @name getCookie
 * @description
 * Get Cookies
 * @param {string} name Cookies name
 * @returns {string} Value of cookie
 */
const getCookie = name => {
    let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
    if (match) return match[1];
    return;
};

/**
 * @name setCookie
 * @description
 * Set a cookie
 * @param {string} name Cookie name
 * @param {string} value Value of cookie
 * @param {string} time.minutes Minutes to expiration cookie
 * @param {string} time.days Days to expiration cookie
 * @param {string} time.hours Hours to expiration cookie
 */
const setCookie = (name, value, time) => {
    let date = new Date();
    if (time.minutes) date.setTime(date.getTime() + time.minutes * 60000);
    if (time.hours) date.setTime(date.getTime() + (time.hours * 60 * 60 * 1000));
    if (time.days) date.setDate(date.getDate() + time.days);
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
    return value;
};

/**
 * @name getUrlParameter
 * @description
 * Get URL Parameter
 * @param {string} name Param name
 * @returns {string} Value of query param
 */
const getUrlParameter = name => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ?
        '' :
        decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * @name getCollection
 * @description
 * Get Collection slug from url
 * @returns {string} Collection slug
 */
const getCollection = () => {
    let path = window.location.pathname.split('/');
    return path[1] === 'collections' ? path[2] : null;
};

/**
 * @name Request
 * @description
 * HTTP Request
 * @param method {string} Request Method
 * @param url {string} URL
 * @param data {object} Post Data
 * @returns {object} Responde Data
 */
const Request = (method, url, data, token) => {
    return new Promise(function (resolve, reject) {
        if(method && url){
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
    
            // Get POST Content Type
            if (method === 'POST' || method === 'PUT') xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    
            // Set Token Authentication in header
            if (token) xhr.setRequestHeader('authorization', 'JWT ' + token);
    
            // Call Request
            xhr.onload = function () {
                resolve(xhr.status === 200 ? JSON.parse(xhr.responseText) : xhr);
            };
    
            // Parse Data
            xhr.send(data ? $.param(data) : null);
        }else{
            resolve;
        }
    });
};

/**
 * @name getSection
 * @description
 * Get section of navigation
 * @return
 * { string } Section URL Slug
 */
const getSection = () => {
    var path = window.location.pathname.split('/');
    return (path[1] === 'pages') ? path[2] : path[1];
};

/**
 * @name string_to_slug
 * @description
 * Build a slug from a string
 * @return
 * {string} Slug generate
 */
window.string_to_slug = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
};